<template>
  <artmisads-modal
    :open="true"
    title="Payment Details"
    :width="1200"
    :onCancel="() => props.setShowPaymentDetailModal(false)"
    :destroyOnClose="true"
    :footer="null"
  >
    <a-spin :spinning="spinning">
      <div class="payment">
        <div class="detail">
          <p>Details</p>
          <div class="filter">
            <div class="button-groups">
              <buttonGroups
                :pagination="{
                  total: listTotal,
                  current: params.page,
                  size: params.size,
                }"
                :tableData="list"
                @pageChange="onPageChange"
              />
               <artmisads-segmented-tabs
                   v-model="activeTab"
                   :items="programConfig"
                   :disabled="spinning"
                   @change="onChangeTab"
                />
            </div>
            <div class="search">
              <artmisads-button-special @click="financeSellerBillingsDetailsBillingIdItemsExport">
                <svg class="icon daochu" aria-hidden="true">
                  <use xlink:href="#icon-daochu"></use>
                </svg>
                <span class="btn-text">Export</span>
              </artmisads-button-special>
              <a-input-search
                v-model:value="params.keyword"
                placeholder="search..."
                @search="getFinanceSellerBillingsDetailsBillingIdItems"
                allowClear="true"
              />
            </div>
          </div>
          <div class="table">
            <artmisads-table
              :columns="columns"
              row-key="id"
              :data-source="list"
              :pagination="{
                total: listTotal,
                current: params.page,
                pageSize: params.size,
                showSizeChanger: true
              }"
              :scroll="{ x: 1500 }"
              :change="onChangePage"
              tableLayout="fixed"
            >
              <template #bodyCell="{ column, record, text }">
                <template v-if="column.name === 'showCurrency'">
                  {{AMAZON_CURRENCY_MAPPER[record.marketplace]}}{{text}}
                </template>
              </template>
            </artmisads-table>
          </div>
        </div>
      </div>
    </a-spin>
  </artmisads-modal>
</template>

<script setup>
import { useRouter } from "vue-router";
import moment from 'moment';
import { keyBy } from 'lodash';
import { AMAZON_CURRENCY_MAPPER, AMAZON_COUNTRY_TIME_TZ } from '~/contants/common';
import { ref, onBeforeMount, computed, onMounted, watch } from "vue";
import { financeApi } from "~/server/operator/finance";
import { COUNTRY_BASE } from "~/contants/common";
import ButtonGroups from '~/pages/seller/Brands/components/buttonGroups.vue';
import { useSystemStore } from '@/storeData/system';
const systemStore = useSystemStore();
const activeTab=ref('0')
const programConfig = computed(() => systemStore.programConfig);
const COUNTRY_BASE_MAP = keyBy(COUNTRY_BASE, 'host');
const router = useRouter();
const props = defineProps([ 'setShowPaymentDetailModal', 'billingId']);
const list = ref([]);
const listTotal = ref(0);
const spinning = ref(false);
const billingBusinessSourceData = ref([
  'amazon_attribution',
  'amazon_associate',
  'amazon_creator_connection',
])
const params = ref({
  page: 1,
  size: 10,
  keyword: null,
});

const columns = [
    {
      title: 'Amazon Seller',
      dataIndex: 'sellerName',
      width: 120,
    },
    {
      title: 'Brand',
      dataIndex: 'brandName',
      width: 120,
    },
    {
      title: 'Publisher Name',
      dataIndex: 'publisherName',
      width: 120,
    },
    {
      title: 'Sales for Commissions',
      dataIndex: 'saleCommissionAmount',
      width: 150,
      name: 'showCurrency',
    },
    {
      title: 'Commissions',
      dataIndex: 'amount',
      width: 140,
      name: 'showCurrency',
    },
    {
      title: 'Media Commission',
      dataIndex: 'commissionAmount',
      width: 140,
      name: 'showCurrency',
    },
    {
      title: 'Platform Commission',
      dataIndex: 'platformFeeAmount',
      width: 140,
      name: 'showCurrency',
    },
  ]
const onChangeTab=(tab)=>{
  params.value.page = 1;
  params.value.size = 10;
  getFinanceSellerBillingsDetailsBillingIdItems()
}
const onChangePage = (data, filters) => {
  const { current, pageSize } = data;
  params.value.page = current;
  params.value.size = pageSize;
  getFinanceSellerBillingsDetailsBillingIdItems();
}

const getFinanceSellerBillingsDetailsBillingIdItems = async () => {
  spinning.value = true;
  const paramsData = { ...params.value, billingId: props.billingId, keyword: params.value.keyword,billingBusinessSource:billingBusinessSourceData.value[activeTab.value] };
  const res = await financeApi.getFinanceSellerBillingsDetailsBillingIdItems(paramsData);
  const { data, total } = res;
  if (res) {
    listTotal.value = total;
    list.value = data;
  }
  spinning.value = false;
};

const onPageChange = current => {
    params.value.page =  current;
    getFinanceSellerBillingsDetailsBillingIdItems();
  }

const financeSellerBillingsDetailsBillingIdItemsExport = () => {
  const finalParams = {
    qs: {
      billingId: props.billingId,
      billingBusinessSource: billingBusinessSourceData.value[activeTab.value],
    },
    fileName: `payment-detail-${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  }
  financeApi.financeSellerBillingsDetailsBillingIdItemsExport(finalParams);
}

onBeforeMount(() => {
  getFinanceSellerBillingsDetailsBillingIdItems();
});
</script>

<style lang="less" scoped>
.payment {
  .info {
    margin-top: 6px;
    .head {
      display: flex;
      justify-content: space-between;
      > p {
        font-weight: 600;
        font-size: 20px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 28px;
      }
    }
  }
 
  .detail {
    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-top: 16px;
      margin-bottom: 16px;
    }
    .filter {
      display: flex;
      justify-content: space-between;
      .button-groups{
        display: flex;
      }
      .search {
        display: flex;
        > button {
          display: flex;
          margin-right: 16px;
          .daochu {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            fill: var(--dark-1);
          }
          > svg {
            align-self: center;
          }
          > span {
            align-self: center;
          }
        }
      }
    }
    .table {
      margin-top: 16px;
    }
  }
  
}
</style>
